@if (state === SetupExtensionState.Loading) {
  <i
    class="bwi bwi-spinner bwi-spin bwi-3x tw-text-muted"
    aria-hidden="true"
    [appA11yTitle]="'loading' | i18n"
  ></i>
}

@if (state === SetupExtensionState.NeedsExtension) {
  <section
    class="tw-mx-auto tw-mt-6 tw-flex tw-w-full tw-max-w-[400px] tw-flex-col tw-items-center tw-rounded-2xl tw-border tw-border-solid tw-border-border-base tw-bg-bg-primary tw-p-7 tw-text-center [box-shadow:var(--vk-shadow-panel)]"
  >
    <div class="tw-mb-4 tw-size-14 [&>bit-svg>svg]:tw-size-14" aria-hidden="true">
      <bit-svg [content]="PartyIcon"></bit-svg>
    </div>
    <h1 class="tw-mb-2 tw-text-[22px] tw-font-bold tw-tracking-[-0.02em] tw-text-fg-heading">
      {{ "setupExtensionPageTitle" | i18n }}
    </h1>
    <p class="tw-mb-6 tw-text-sm tw-text-fg-muted">
      {{ "setupExtensionPageDescription" | i18n }}
    </p>
    <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-3">
      <a
        bitButton
        buttonType="primary"
        class="tw-w-full"
        [href]="webStoreUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ "getTheExtension" | i18n }}
      </a>
      <button type="button" bitLink linkType="subtle" class="tw-text-sm" (click)="addItLater()">
        {{ "addItLater" | i18n }}
      </button>
    </div>
  </section>
}

@if (showSuccessUI) {
  <section
    class="tw-mx-auto tw-mt-6 tw-flex tw-w-full tw-max-w-[400px] tw-flex-col tw-items-center tw-rounded-2xl tw-border tw-border-solid tw-border-border-base tw-bg-bg-primary tw-p-7 tw-text-center [box-shadow:var(--vk-shadow-panel)]"
  >
    <div class="tw-mb-4 tw-size-14 [&>bit-svg>svg]:tw-size-14" aria-hidden="true">
      <bit-svg [content]="PartyIcon"></bit-svg>
    </div>
    <h1 class="tw-mb-2 tw-text-[22px] tw-font-bold tw-tracking-[-0.02em] tw-text-fg-heading">
      {{
        (state === SetupExtensionState.Success
          ? "vowkeyExtensionInstalled"
          : "vowkeyExtensionIsInstalled"
        ) | i18n
      }}
    </h1>
    <p class="tw-mb-6 tw-text-sm tw-text-fg-muted">
      {{ "openExtensionToAutofill" | i18n }}
    </p>
    <div class="tw-flex tw-w-full tw-flex-col tw-gap-2.5">
      <button
        type="button"
        bitButton
        buttonType="primary"
        class="tw-w-full"
        (click)="openExtension()"
      >
        {{ "openVowkeyExtension" | i18n }}
      </button>
      <a bitButton buttonType="secondary" class="tw-w-full" routerLink="/vault">
        {{ "skipToWebApp" | i18n }}
      </a>
    </div>
    @if (state === SetupExtensionState.ManualOpen) {
      <div aria-live="polite" class="tw-mt-4 tw-text-center">
        <vault-manually-open-extension></vault-manually-open-extension>
      </div>
    }
  </section>
}
